import React from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import { Redirect, Router, Route, Switch } from "react-router-dom";
import ErrorBoundary from "./components/SkyFramework/Helpers/ErrorBoundary";

import { store, history } from 'helpers';
import { languageActions } from 'actions';
import indexRoutes from "routes/index.jsx";

languageActions.update();
console.log = function () { };
console.log(process.env.REACT_APP_API_END_POINT_URL)
console.log(process.env.REACT_APP_ENABLE_ORDER)
ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.to} key={key} />;
          return <Route path={prop.path} component={prop.component} key={key} />;
        })}
      </Switch>
    </Router>
  </Provider>,


  document.getElementById("root")
);
